import {
    MdReply,
    MdReplyAll,
    MdForward,
    MdStarBorder,
    MdStar,
    MdArchive,
    MdDelete,
    MdMarkunread,
    MdRestoreFromTrash,
} from 'react-icons/md'

interface MessageActionsProps {
    isStarred: boolean
    isRead: boolean
    isTrashed: boolean
    onReply: () => void
    onReplyAll: () => void
    onForward: () => void
    onToggleStar: () => void
    onArchive: () => void
    onTrash: () => void
    onUntrash: () => void
    onToggleRead: () => void
    canUpdate?: boolean
    canCreate?: boolean
}

export default function MessageActions({
    isStarred,
    isRead,
    isTrashed,
    onReply,
    onReplyAll,
    onForward,
    onToggleStar,
    onArchive,
    onTrash,
    onUntrash,
    onToggleRead,
    canUpdate,
    canCreate,
}: MessageActionsProps) {
    return (
        <div className="flex items-center gap-1 flex-wrap">
            {canCreate && (
                <>
                    <button
                        onClick={onReply}
                        className="btn btn-ghost btn-xs gap-1"
                        title="Responder"
                    >
                        <MdReply className="text-base" />
                        <span className="hidden sm:inline">Responder</span>
                    </button>
                    <button
                        onClick={onReplyAll}
                        className="btn btn-ghost btn-xs gap-1"
                        title="Responder a todos"
                    >
                        <MdReplyAll className="text-base" />
                        <span className="hidden sm:inline">
                            Responder a todos
                        </span>
                    </button>
                    <button
                        onClick={onForward}
                        className="btn btn-ghost btn-xs gap-1"
                        title="Encaminhar"
                    >
                        <MdForward className="text-base" />
                        <span className="hidden sm:inline">Encaminhar</span>
                    </button>
                </>
            )}

            {canUpdate && (
                <>
                    <div className="divider divider-horizontal mx-0.5" />
                    <button
                        onClick={onToggleStar}
                        className="btn btn-ghost btn-xs"
                        title={
                            isStarred
                                ? 'Remover estrela'
                                : 'Adicionar estrela'
                        }
                    >
                        {isStarred ? (
                            <MdStar className="text-base text-warning" />
                        ) : (
                            <MdStarBorder className="text-base" />
                        )}
                    </button>
                    <button
                        onClick={onArchive}
                        className="btn btn-ghost btn-xs"
                        title="Arquivar"
                    >
                        <MdArchive className="text-base" />
                    </button>
                    {isTrashed ? (
                        <button
                            onClick={onUntrash}
                            className="btn btn-ghost btn-xs"
                            title="Restaurar da lixeira"
                        >
                            <MdRestoreFromTrash className="text-base" />
                        </button>
                    ) : (
                        <button
                            onClick={onTrash}
                            className="btn btn-ghost btn-xs"
                            title="Mover para lixeira"
                        >
                            <MdDelete className="text-base" />
                        </button>
                    )}
                    <button
                        onClick={onToggleRead}
                        className="btn btn-ghost btn-xs"
                        title={
                            isRead
                                ? 'Marcar como não lido'
                                : 'Marcar como lido'
                        }
                    >
                        <MdMarkunread className="text-base" />
                    </button>
                </>
            )}
        </div>
    )
}
